import {
  cruiseListRequest,
  cruiseRequest,
  cruiseListResponse,
} from '../generated';
import { cache } from 'react';
import { tryRequest } from '../utils/try-request';
import { createCssClient } from '../utils';
import { logger } from '@tuic/logger';

export type CruiseListRequestParams = Omit<cruiseListRequest, 'cruise'> & {
  period: {
    start: {
      preOffset?: number;
      postOffset?: number;
    };
    end?: {
      preOffset?: number;
      postOffset?: number;
    };
  };
} & {
  cruise?: Omit<cruiseRequest, 'cabinTypes'> & {
    cabinTypes?: string[];
  };
};

/**
 * @deprecated Nutzung von `getCruiseList` bevorzugen für klare Zustandsrückgaben.
 */
export const postCruiseList = cache(async (params: CruiseListRequestParams) => {
  const css = createCssClient();

  return await tryRequest(
    () => {
      return css.listSearch.postCruiseList(params as cruiseListRequest);
    },
    `Could not fetch cruise list.  Params: ${JSON.stringify(params)}`,
  );
});

type PostCruiseList =
  | { state: 'success'; data: cruiseListResponse }
  | { state: 'error'; message?: string };

/**
 *
 */
export const getCruiseList = cache(
  async (params: CruiseListRequestParams): Promise<PostCruiseList> => {
    const css = createCssClient();

    try {
      const searchResponse = await css.listSearch.postCruiseList(
        params as cruiseListRequest,
      );
      return {
        state: 'success',
        data: searchResponse,
      };
    } catch (error) {
      logger.error(error);
      logger.error(
        `Could not fetch cruise list.  Params: ${JSON.stringify(params)}`,
      );

      return { state: 'error', message: 'Could not fetch cruise list' };
    }
  },
);
